const allowSignPendingStates = {
  PE: ['laboratory', 'heavy_metals', 'exams', 'company_doctor'],
};

export default allowSignPendingStates;